/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioUpdateRequestSchema = z.object({
  capacityUtilization: z.enum(['LOW', 'MEDIUM', 'HIGH', 'NOOP']).nullish(),
  color: z.string().nullish(),
  colorSecondary: z.string().nullish(),
  description: z.string().nullish(),
  estimationBuffer: z.enum(['LOW', 'MEDIUM', 'HIGH', 'NOOP']).nullish(),
  name: z.string().nullish(),
  priorityFlexibility: z.enum(['LOW', 'MEDIUM', 'HIGH', 'NOOP']).nullish(),
});
